module.exports = __webpack_public_path__ + "static/media/smartx_enabled.691b07fd.svg";